module.exports = __webpack_public_path__ + "static/media/s9.f1faed95.ogg";